import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=be0d6098&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d6098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be0d6098')) {
      api.createRecord('be0d6098', component.options)
    } else {
      api.reload('be0d6098', component.options)
    }
    module.hot.accept("./ClientList.vue?vue&type=template&id=be0d6098&scoped=true&", function () {
      api.rerender('be0d6098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ClientList.vue"
export default component.exports